import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import { mockDataContacts } from "../../data/mockData";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import React, { useState, useEffect } from 'react';

const Contacts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { field: "registrarId", headerName: "Registrar ID" },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "age",
      headerName: "Age",
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "contact",
      headerName: "Phone Number",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      flex: 1,
    },
    {
      field: "city",
      headerName: "City",
      flex: 1,
    },
    {
      field: "zipCode",
      headerName: "Zip Code",
      flex: 1,
    },
  ];
  var data_columns = [];
  const [data, setData] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);

  const handleResponse = (str_data) => {
    console.log("Excecuted");
    var data = str_data;
    console.log(data);
    var obj = data[0];
    var keys = Object.keys(obj);
    console.log(keys);
    var headers = [];
    keys.map((key)=>{
      headers.push({
        "field":key,
        "headerName": key,
         flex: 1,
      })
    });
    setDataColumns(headers);
    console.log(dataColumns);

   setData(data);
  }

  useEffect(() => {
    var fields_values = [];
      fields_values.push({
        "name":"*",
        "value":""
      })
   
    var joke = {
      "data": {
          "action":"get",
          "name": "TestingTable",
          "fields": fields_values
      }
  };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(joke),
      redirect: "follow"
    };
   
    fetch("http://BR-MVU-FA.org/api/spares.php", requestOptions)
      .then((response) => response.json())
      .then((result) => handleResponse(result))
      .catch((error) => console.error(error));
 },[]);

  return (
    <Box m="20px">
      <Header
        title="CONTACTS"
        subtitle="List of Contacts for Future Reference"
      />
      <Box

        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        {
          data.length >0 &&
        <DataGrid
          rows={data}
          columns={dataColumns}
          components={{ Toolbar: GridToolbar }}
        />
}

      </Box>
    </Box>
  );
};

export default Contacts;
